/**
 * eRCMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TranslatedCaseDto } from './translatedCaseDto';

export interface TranslatedTransferModalityDto { 
    id?: string;
    translatedLanguage?: string;
    translatedCaseId?: string;
    translatedCase?: TranslatedCaseDto;
    transferDocumentNo?: string;
    returneeIssuingAuthority?: string;
    returneePlaceOfIssuance?: string;
    escortIssuingAuthority?: string;
    escortPlaceOfIssuance?: string;
}